exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_navigationBarContentWrapper_3ej9405_pXwzWkramfJwzk {\n  display: flex;\n  height: 100%;\n  flex-direction: row-reverse;\n  align-Items: center;\n}\n\n.IA_templateEditorWrapper_IqTSoHQDUBsofir5C8yuO {\n  display: flex;\n  flex-direction: column;\n  padding: 0 40px;\n}\n\n.IA_createTemplateButtonWrapper_38frYWyvSXTdmyN-yX_r7E {\n  margin-top: 25px;\n}", ""]);

// Exports
exports.locals = {
	"IA_navigationBarContentWrapper": "IA_navigationBarContentWrapper_3ej9405_pXwzWkramfJwzk",
	"IA_templateEditorWrapper": "IA_templateEditorWrapper_IqTSoHQDUBsofir5C8yuO",
	"IA_createTemplateButtonWrapper": "IA_createTemplateButtonWrapper_38frYWyvSXTdmyN-yX_r7E"
};